<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn
        color="primary"
        @click="CHANGE_MOVIMENTI_COMPONENT('Index')"
      >Indietro</v-btn>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-card min-width="100%">
        <v-card-text>
          <!-- #datepicker -->
          <v-col>
            <v-row>
              <v-col>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="posix"
                      label="Data"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="posix"
                    no-title
                    scrollable
                    actions
                    locale="it-IT"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                class="flex flex-col items-bottm"
                md="1"
              >
                <v-btn
                  style="width: 100%;"
                  color="primary"
                  @click="posix = new Date().toISOString().substr(0, 10)"
                >Oggi</v-btn>
              </v-col>
            </v-row>
          </v-col>

          <!-- #form -->
          <v-form
            ref="form"
            v-model="valid"
            :lazy-validation="true"
            autocomplete="off"
          >
            <v-col>
              <v-row>
                <v-col>
                  <v-select
                    label="Tipologia"
                    :items="[
											{ text: 'Seleziona una tipologia', value: null },
											{ text: 'Entrata', value: 'entrata' },
											{ text: 'Uscita', value: 'uscita' },
										]"
                    item-text="text"
                    item-value="value"
                    v-model="newMovement.kind"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    label="Categoria"
                    :items="categories"
                    item-text="title"
                    item-value="id"
                    v-model="newMovement.category_id"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>

                <v-col>
                  <v-text-field
                    type="number"
                    label="Valore"
                    v-model="newMovement.price"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-textarea
                    label="Descrizione"
                    v-model="newMovement.description"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col>
            <v-row>
              <v-col>
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="insert"
                >
                  Inserici Movimento
                </v-btn>

                <v-btn
                  color="error"
                  class="mr-4"
                  @click="reset"
                >
                  Reset Modulo
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters, mapActions } from 'vuex'

  import SnackNotification from './../SnackNotification'

  export default {
    name: 'Insert',
    components: {
      SnackNotification,
    },
    data() {
      return {
        // #data
        posix: new Date().toISOString().substr(0, 10),
        categories: [],
        newMovement: {
          kind: null,
          category_id: null,
          name: undefined,
          price: undefined,
          description: undefined,
        },
        // #options
        menu: false,
        valid: false,
        snack: {
          error: null,
          visible: null,
          message: null,
        },
        // #validation
        rules: {
          required: (value) => !!value || 'Campo obbligatorio.',
        },
        // #api
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },
    methods: {
      ...mapMutations(['CHANGE_MOVIMENTI_COMPONENT']),
      ...mapActions(['insert_new_movement']),
      async insert() {
        if (this.$refs.form.validate()) {
          this.snack = Object.assign(
            {},
            {
              error: null,
              visible: null,
              message: null,
            }
          )

          this.newMovement.posix = this.posix

          try {
            await this.insert_new_movement(this.newMovement)

            this.snack = Object.assign(
              {},
              {
                visible: true,
                error: false,
                message: 'Movimento salvato correttamente!',
              }
            )
          } catch (error) {
            console.error(error)

            this.snack = Object.assign(
              {},
              {
                visible: true,
                error: true,
                message: 'Errore nel salvataggio.',
              }
            )
          }
        }
      },
      reset() {
        this.$refs.form.reset()
      },
    },

    async created() {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API}/categories/by-reference`,
        { reference: 'movimenti' },
        this.config
      )

      console.log(data)

      this.categories = data
    },
  }
</script>
